import type { LandIqBoardColumn, LandIqBoardTicket, MoveLandIqDataRunTicketResponse } from '@immo/api-contract';
import { apiClient } from '@/lib/auth/api-client';

export type MoveRefusal = Extract<MoveLandIqDataRunTicketResponse, { outcome: 'REFUSED' }>;

export type MoveOutcome =
  | { kind: 'moved'; ticket: LandIqBoardTicket }
  | { kind: 'refused'; refusal: MoveRefusal }
  | { kind: 'failed'; code: string | undefined };

/** Asks LandIQ to start the stage `to` of a board ticket. Shared by the board's drop and the run page's button. */
export async function moveTicket(ticket: string, to: LandIqBoardColumn): Promise<MoveOutcome> {
  try {
    const result = await apiClient.adminLandiqDataRuns.move({ pathParams: { ticket }, body: { to } });

    if (!result.ok) {
      return { kind: 'failed', code: (result.body as { error?: { code?: string } } | undefined)?.error?.code };
    }

    if (result.body.outcome === 'MOVED') return { kind: 'moved', ticket: result.body.ticket };

    return { kind: 'refused', refusal: result.body };
  } catch {
    return { kind: 'failed', code: undefined };
  }
}
